<mat-nav-list>
  <h3 class="subheader">Kies een dienst</h3>
  @for (dienst of diensten.getDiensten(); track dienst) {
    <mat-list-item
      (click)="onDienstClicked(dienst)">
      <span matListItemAvatar [ngClass]="dienst.getIcoon()"></span>
      <a matListItemTitle>{{dienst.getLabel()}}</a>
    </mat-list-item>
  }
  @if (!diensten.hasDiensten()) {
    <mat-list-item
      class="no-list-item-highlight"
      disableRipple>
      <div matListItemTitle>Er zijn geen diensten voor deze cliënt. Contacteer je dienst.</div>
    </mat-list-item>
  }
</mat-nav-list>
